/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Welcome_Suggestion_Just_ExploringInputs */



/**
* | output |
* | --- |
* | "Show me around" |
*
* @param {Uno_Welcome_Suggestion_Just_ExploringInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_welcome_suggestion_just_exploring = /** @type {((inputs?: Uno_Welcome_Suggestion_Just_ExploringInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Welcome_Suggestion_Just_ExploringInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zeig mir alles")
	return /** @type {LocalizedString} */ ("Show me around")
});